import { dateToFrench } from 'utils/date';
import { useNavigate } from 'react-router-dom';
import Card from 'components/card';
import { IOrderPreparation, IPreparationLine } from 'interfaces/orderPreparationTypes';

const statusLabels = {
    draft: 'Brouillon',
    in_progress: 'En cours',
    completed: 'Terminée',
    cancelled: 'Annulée'
};

const statusColors = {
    draft: 'bg-gray-500',
    in_progress: 'bg-[#0260CB]',
    completed: 'bg-green-500',
    cancelled: 'bg-red-500'
};

const PreparationCard = (props: {
    preparation: IOrderPreparation;
    extra?: string;
}) => {
    const { preparation, extra } = props;
    const nav = useNavigate();

    const totalProducts = preparation.preparationLines.length;
    const totalPrepared = preparation.preparationLines.reduce(
        (sum: number, line: IPreparationLine) => sum + line.quantityPrepared,
        0
    );

    return (
        <Card
            extra={`flex flex-col w-full h-[185px] !p-4 3xl:p-![18px] bg-white border border-[#7090B0]/[0.25] hover:cursor-pointer ${extra}`}
            onClick={() => nav(`/preparations/${preparation._id}`)}
        >
            <div className="h-full w-full">
                <div className="mb-3 flex items-center justify-between px-1 md:flex-col md:items-start lg:flex-row lg:justify-between xl:flex-col xl:items-start 3xl:flex-row 3xl:justify-between">
                    <div className="mb-2 w-full">
                        <div className="flex justify-between items-start">
                            <p className="text-base font-medium text-navy-700 dark:text-white">
                                Commande {preparation.orderNumber}
                            </p>
                            <span className={`text-white ${statusColors[preparation.status as keyof typeof statusColors]} px-2 py-1 rounded-xl text-[10px]`}>
                                {statusLabels[preparation.status as keyof typeof statusLabels]}
                            </span>
                        </div>
                        
                        <p className="mt-2 mb-2 text-sm text-[#A3AED0] dark:text-white">
                            Créée le {dateToFrench(preparation.createdAt).toLowerCase()}
                        </p>
                        
                        <div className="space-y-1">
                            <p className="text-xs text-[#A3AED0] dark:text-white">
                                {totalProducts} produit{totalProducts > 1 ? 's' : ''} à préparer
                            </p>
                            {preparation.preparedBy && (
                                <p className="text-xs text-[#A3AED0] dark:text-white">
                                    Préparateur: {preparation.preparedBy.fullName}
                                </p>
                            )}
                        </div>
                    </div>
                </div>

                {preparation.status === 'completed' && preparation.validatedAt && (
                    <div className="absolute bottom-3">
                        <p className="text-xs text-green-600 ml-2">
                            ✓ Validée le {dateToFrench(preparation.validatedAt)}
                        </p>
                    </div>
                )}

                {preparation.status === 'in_progress' && (
                    <div className="absolute bottom-3">
                        <p className="text-xs text-[#0260CB] ml-2">
                            🔄 Préparation en cours...
                        </p>
                    </div>
                )}
            </div>
        </Card>
    );
};

export default PreparationCard;
